/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from '../../services/Cart/actions';
import * as creditActions from './actions';
import * as Constants from './Constants';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import logger from '../../components/common/ErrorBoundary/logger_new';
// import { catchHandle } from '../CreditCheck/sagas';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';

function* callValidateOrder({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CREDIT_STATUS_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponse = yield call(Actions.reviewOrderCall, data);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
      const validateOrder = apiResponse.data?.serviceBody?.serviceResponse?.context?.validateOrder || {};
      const validatedHoldOrder = validateOrder?.orderDetails?.[0]?.creditHoldContent || false;
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      yield put({ type: Constants.UPDATE_VALIDATE_ORDER, response: validateOrder });
      if (!validatedHoldOrder) {
        yield put({ type: Constants.VALIDATED_HOLD_ORDER, response: true });
      } else {
        yield put({ type: Constants.VALIDATED_HOLD_ORDER, response: false });
      }
      hideLoader();
    } else {
      hideLoader();
      yield put({
        type: Constants.CEF_CREDIT_STATUS_ERROR,
        response: true,
        errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
      });

      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `callValidateOrder ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    hideLoader();
    yield put({ type: Constants.ERR_OCCURED });
    yield put({
      type: Constants.CEF_CREDIT_STATUS_ERROR,
      response: true,
      errorMessage: 'Looks like something went wrong. Please try again later.',
    });
    // logError('callValidateOrder', error, FE_API_JS_ERROR);
  }
}

function* resubmitCall({ data }) {
  yield put({ type: Constants.CEF_CREDIT_STATUS_ERROR, response: false, errorMessage: null });
  try {
    showLoader();
    const apiResponse = yield call(creditActions.reSubmitCreditReviewApi, data);

    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        // yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS, response: true });
        yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS_DATA, response: true });
        yield put({ type: 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE_STATUS', response: apiResponse.data.serviceBody });
        yield put({ type: 'RUN_CREDIT_DOWNPAYMENT_SUCCESS_RESPONSE', response: apiResponse.data.serviceBody });
        // yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS, response: true });
        hideLoader();
      }
    } else {
      yield put({ type: Constants.RESUBMIT_CREDIT_FAILED, response: apiResponse.data.errors });
      yield put({ type: Constants.CEF_CREDIT_STATUS_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      hideLoader();

      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `resubmitcall- runCreditReview ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    yield put({
      type: Constants.CEF_CREDIT_STATUS_ERROR,
      response: true,
      errorMessage: 'Looks like something went wrong. Please try again later.',
    });
    // yield catchHandle(error);
    hideLoader();
  }
}

function* updateCreditCheckSuccess() {
  yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS, response: false });
}

function* creditStatusLanded() {
  yield put({ type: Constants.CREDIT_STATUS_LANDED, response: true });
}

function* resetOrderStatus() {
  yield put({ type: Constants.VALIDATED_HOLD_ORDER, response: false });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_VALIDATEORDER, callValidateOrder);
  yield takeLatest(Constants.RESET_ORDER_STATUS, resetOrderStatus);
  yield takeLatest(Constants.TRIGGER_CREDIT_STATUS_LANDED, creditStatusLanded);
  yield takeLatest('RESUMBIT_CREDIT_REVIEW', resubmitCall);
  yield takeLatest('UPDATE_CREDIT_REVIEW', updateCreditCheckSuccess);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
